"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsonrpc = require("../jsonrpc");

var _web3Calls = _interopRequireDefault(require("../web3Calls"));

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _misc = _interopRequireDefault(require("../../helpers/misc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = async (_ref, res, next) => {
  let payload = _ref.payload,
      store = _ref.store,
      requestManager = _ref.requestManager;
  if (payload.method !== 'eth_getTransactionCount') return next();
  const ethCalls = new _web3Calls.default(requestManager);
  const addr = payload.params[0];
  let cached = {};

  if (store.nonceCache === undefined) {
    cached = {
      nonce: '0x00',
      timestamp: 0
    };
  } else {
    cached = store.nonceCache;
  }

  const timeDiff = Math.round((new Date().getTime() - cached.timestamp) / 1000) / 30;

  if (timeDiff > 1) {
    const liveNonce = await ethCalls.getTransactionCount(addr);
    const liveNonceBN = new _bignumber.default(liveNonce);
    const cachedNonceBN = new _bignumber.default(cached.nonce);

    if (timeDiff > 15) {
      cached = {
        nonce: _misc.default.sanitizeHex(liveNonceBN.toString(16)),
        timestamp: +new Date()
      };
    } else if (liveNonceBN.isGreaterThan(cachedNonceBN)) {
      cached = {
        nonce: _misc.default.sanitizeHex(liveNonceBN.toString(16)),
        timestamp: +new Date()
      };
    }

    store.nonceCache = cached;
  }

  res(null, (0, _jsonrpc.toPayload)(payload.id, cached.nonce));
};

exports.default = _default;